import { useTranslation } from 'react-i18next'

import { TextBIcon, TextItalicIcon } from '@phosphor-icons/react'

import { ColorPicker, ComboBox, Divider, Text } from '@reveni-io/reveni-ui'

import { fontFamilies, fontSizes, textStyleFields } from './constants'
import * as Styles from './styles'

const TextStylesTab = ({
  textStyles,
  onFontFamilyChange,
  onFontSizeChange,
  onBoldToggle,
  onItalicToggle,
  onTextColorChange,
  linkColor,
  onLinkColorChange,
  disabled,
}) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Text type="bodyMRegular">
        {t('Configura los estilos de texto predeterminados para usar en tus plantillas de email')}
      </Text>
      <Styles.TextStylesContainer>
        {textStyleFields.map((field, index) => (
          <>
            <div key={field.key}>
              <Styles.SectionContainer>
                <Text type="bodyMBold">{t(field.label)}</Text>
                <Styles.FontRow>
                  <ComboBox
                    fullWidth
                    label={t('Tipografía')}
                    menuItems={fontFamilies}
                    value={textStyles[field.key].fontFamily}
                    handleChange={e => onFontFamilyChange(field.key, e.target.value)}
                    disabled={disabled}
                  />
                  <ComboBox
                    fullWidth
                    label={t('Tamaño')}
                    menuItems={fontSizes}
                    value={String(textStyles[field.key].fontSize)}
                    handleChange={e => onFontSizeChange(field.key, e.target.value)}
                    disabled={disabled}
                  />
                  <Styles.ToggleButton
                    active={textStyles[field.key].bold}
                    type="button"
                    aria-label={t('Negrita')}
                    onClick={() => onBoldToggle(field.key)}
                    disabled={disabled}
                  >
                    <TextBIcon size={32} weight="bold" />
                  </Styles.ToggleButton>
                  <Styles.ToggleButton
                    active={textStyles[field.key].italic}
                    type="button"
                    aria-label={t('Cursiva')}
                    onClick={() => onItalicToggle(field.key)}
                    disabled={disabled}
                  >
                    <TextItalicIcon size={32} />
                  </Styles.ToggleButton>
                </Styles.FontRow>
              </Styles.SectionContainer>
              <ColorPicker
                label={t('Color de texto')}
                value={textStyles[field.key].color}
                defaultColor={textStyles[field.key].color}
                onChange={color => onTextColorChange(field.key, color)}
                disabled={disabled}
              />
            </div>
            {index < textStyleFields.length - 1 && <Divider />}
          </>
        ))}
        <Divider />
        <Styles.SectionContainer>
          <Text type="titleS">{t('Enlaces')}</Text>
          <ColorPicker label={t('Color de texto')} value={linkColor} onChange={onLinkColorChange} disabled={disabled} />
        </Styles.SectionContainer>
      </Styles.TextStylesContainer>
    </Styles.Container>
  )
}

export default TextStylesTab
